import React from "react";
import Routes from "./routes";
import GlobalStyle from "./style/Global";


function App() {
  return (
    <>
    
      <GlobalStyle />
      <Routes />
      
    </>
  );
}

export default App;
